$(document).ready(function () {
  // var youTubeUrl = $("#video").attr("src");
  // $("#play-video").on("click", function (e) {
  //   $("#video")[0].src += "?&autoplay=1";
  //   e.preventDefault();
  // });
  // $("#stop-video").on("click", function (e) {
  //   e.preventDefault();
  //   $("#video").attr("src", "");
  //   $("#video").attr("src", youTubeUrl);
  // });
  $(".custom-poster-image").click(function () {
    $(".youtube-video-text-inner").addClass("active")
    $(".custom-poster-image").addClass("active");
  });

  var getAttCount = $(this).find(".count-result-price").attr("getCountAtt");
  $(".custom-count-price-add").text(getAttCount);
  const priceVal = $(".custom-varinat-input-name:checked").attr(
    "cuspricecount"
  );
  const priceSplitVal = priceVal.split("$");
  const qtyVal = $(".custom-varinat-input-name:checked").val();
  const qtySplitVal = qtyVal.split(" ");
  const pricePerPiece = priceSplitVal[1] / qtySplitVal[0];
  if (pricePerPiece) {
    const perPieceVal = pricePerPiece.toFixed(2).replace(/(\.00\0+|0+)$/, "");
    const dta = perPieceVal.split(".");
    if (dta[1]) {
      $(".custom-count-price-add").text("($" + perPieceVal + "/count)");
    } else {
      $(".custom-count-price-add").text("($" + dta[0] + ".0" + "/count)");
    }
  }
  $(".custom_input_change").click(function () {
    if ($('.subscription-radio').hasClass('rc-radio--active')) {
      // Change the JS variable
    window.variantStrings.addToCart = "Start Autoship";
    const submitButton = document.querySelector(".custom-product-form__submit");
    const span = submitButton?.querySelector("span");
    if (span) {
      span.textContent = window.variantStrings.addToCart;
    }
    }
    var getAttCount = $(this).find(".count-result-price").attr("getCountAtt");
    var prohandle = $(this).data('prohandle');
    var vartitle = $(this).parent('.slideitem').find('.custom-varinat-input-name').val();

    var count = $('input[name="Count"]:checked , input[name="Choose Count:"]:checked').val(); 
    var scent = $('input[name="Scent"]:checked , input[name="Choose Scent:"]:checked, input[name="Scent:"]:checked').val();
    var countDataon = $(this).parents('.option-custom-no-1').attr('dataon');
    var scentDataon =  $(this).parents('.option-custom-no-2').attr('dataon');
    if(countDataon){
      if(scent){
         var variantTitlewithOption = vartitle+' / '+scent;
      }else{
         var variantTitlewithOption = vartitle;
      }
      variantdata(prohandle,variantTitlewithOption);
    }else{
      var variantTitlewithOption = count+' / '+vartitle;
      variantdata(prohandle,variantTitlewithOption);
    }
    
    if (getAttCount) {
      $(".custom-count-price-add").text(getAttCount);
    }
  });
});
function variantdata(productHandle, variantTitle) {
    $.getJSON("/products/" + productHandle + ".js", function(result) {
        var thumbnail = '<div class="slider-for-variant">';
        var matched = false;
        $.each(result.media, function(i, img) {
            if (img.alt !== null) {
                if (img.alt.indexOf('_') !== -1) {
                    var alt = img.alt.split('_');
                    //var alt = altImage[1].split(' / ');
                    if (alt[1] == variantTitle) {
                        matched = true;
                        if (img.media_type === 'video' || img.media_type === 'external_video') {
                            $.each(img.sources, function(i, video) {
                                $('.slider-for-variant .slick-slide.slick-current.slick-active').html('<video width="100%" controls autoplay muted poster="' + img.preview_image.src + '"><source src="' + video.url[0] + '" type="video/mp4"></video></div>');
                                $('.desktop-slider-nav-variant [data-slick-index="0"]').html('<video width="100%" controls autoplay muted poster="' + img.preview_image.src + '"><source src="' + video.url[0] + '" type="video/mp4"></video></div>');
                               $('.slider-nav-variant [data-slick-index="0"]').html('<video width="100%" controls autoplay muted poster="' + img.preview_image.src + '"><source src="' + video.url[0] + '" type="video/mp4"></video></div>');
                            });
                        } else {
                          // console.log('----',img.src)
                            if($('.slider-for-variant [data-slick-index="0"] .video-poster').length){
                          
                              $('.slider-for-variant').slick('slickAdd', `<div class="slick-slide" data-slick-index="0" aria-hidden="true" tabindex="-1"><div><div class="item img-wrapper">
                                                              <img src="`+img.src+`"  loading="lazy" alt="PetsWorld Cat Litter Pads Breeze Compatible Refills_">
                                                            </div></div></div>`, 0, true);
                              $('.desktop-slider-nav-variant').slick('slickAdd', `<div class="slick-slide slick-active" data-slick-index="0" aria-hidden="false"><div><div class="item" style="display: inline-block;">
                                        <img src="`+img.src+`" loading="lazy" alt="PetsWorld Cat Litter Pads Breeze Compatible Refills_">
                                      </div></div></div>`, 0, true);
                              $('.slider-nav-variant').slick('slickAdd', `<div class="slick-slide slick-active" data-slick-index="0" aria-hidden="false"><div><div class="item" style="display: inline-block;">
                                        <img src="`+img.src+`" loading="lazy" alt="PetsWorld Cat Litter Pads Breeze Compatible Refills_">
                                      </div></div></div>`, 0, true);
                            
                            }
                            else{
                              $('.desktop-slider-nav-variant').slick('slickGoTo', 0);
                              $('.slider-for-variant .slick-slide.slick-current.slick-active img').attr('src', img.src);
                              $('.desktop-slider-nav-variant [data-slick-index="0"] img').attr('src', img.src);
                              $('.slider-nav-variant').slick('slickGoTo', 0);
                              $('.slider-nav-variant [data-slick-index="0"] img').attr('src', img.src);
                            }
                           
                          return false;
                        }
                     }
                    // else{
                    //     $('.desktop-slider-nav-variant').slick('slickGoTo', 0);
                    //     $('.slider-for-variant').slick('slickGoTo', 0);
                    //     $('.slider-nav-variant').slick('slickGoTo', 0);
                    //  }
                }
            }
        });
        if (!matched) {
          if($('.slider-for-variant .slick-slide:nth-child(2) .item.video-poster').length){
            var goto = $('.slider-for-variant .video-poster').first().closest('.slick-slide').index();
             $('.slider-for-variant').slick('slickGoTo', goto);
          }
         else{
            $('.desktop-slider-nav-variant').slick('slickGoTo', 0);
            $('.slider-for-variant').slick('slickGoTo', 0);
            $('.slider-nav-variant').slick('slickGoTo', 0);
         }
        }
    });
}

